module.exports = __webpack_public_path__ + "img/voie-maltee-quebec.7b2ae833.png";